<template lang="pug">
    v-card-text
        v-layout( row wrap )
            v-flex( xs12 )
                crud-data-table(
                    @detail="showDetailRemun($event)"
                    no-search
                    no-filter
                    no-pagination
                    show-native-pagination
                    v-bind='tableProps'
                    v-model='table.items'
                    noRemove
                    )
                detail-dialog(ref="refSalaryDetails" :salarySettlementId="salarySettlementId")
</template>

<script>
import RemunerationsHeaders from './headers/RemunerationsHeaders'
//-
import DialogSalarySettlement from './partials/DialogRemunerationsDetail'
import {
    ModelDataTable,
} from '@/components/reusable_components/next'
import EmployeeService from '@/services/api/employee'

export default {
    name: 'remunerations',
    props: {},
    data: function(){
        return {
            headers: RemunerationsHeaders,
            salarySettlementId: 0,
            filters: [],
            table: {
                headers: RemunerationsHeaders,
                items: [],
            },
        }
    },
    computed: {
        /**
         *
         */
        tableProps() {
            return {
                ...this.table,
                noDataText: 'Sin remuneraciones.',
                rowsPerPageText: 'remuneraciones por pagina',
            }
        },
    },
    methods: {
        getInfoRemunerationsEmployee: async function() {
            const idEmployee = this.$route.params.id
            let response = await EmployeeService.remunerations(idEmployee)
            this.table.items = response.data
        },
        showDetailRemun: function(event) {
            this.salarySettlementId = event.item.id
            this.$refs.refSalaryDetails.open = true
        }
    },
    watch: {},
    components: {
        'crud-data-table': ModelDataTable,
        'detail-dialog': DialogSalarySettlement,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: async function(){
        this.getInfoRemunerationsEmployee()
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>